import { useWorkspaceAssetLifecyclePolicyFragment } from '../gql/generated/fragments';

export function useWorkspaceAssetLifecyclePolicy(
  workspaceId: string | null | undefined
) {
  const { data } = useWorkspaceAssetLifecyclePolicyFragment(workspaceId);

  const days = data?.daysBeforeAssetAutoDeletion;

  return {
    daysBeforeAssetAutoDeletion: days,
    enabled: days !== undefined && days !== null && days !== 0,
  };
}
